import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import View404 from './View404';
import ViewForm from './ViewForm';
import ViewSuccess from './ViewSuccess';

import Footer from './Footer';

import './compiled/App.css';
import logo from './svg/logo.svg';
import APP_DATA from './compiled/app.json';

class App extends Component {
  // Constructor
  constructor() {
    super();

    this.state = {};
  }

  // // Life-cycle
  // componentDidMount() {}

  // Handlers

  // Render
  render() {
    let form_logo = logo; // TODO - put in data file?
    let form_title = APP_DATA.title;
    let form_help = APP_DATA.help;
    let fields = APP_DATA.fields;

    return (
      <Router>
        <div className="App">
          <div id="content" className="col">
            <div className="container header">
              <div className="media">
                <img
                  className="logo media-item"
                  width="50"
                  src={form_logo}
                  alt="logo"
                />
                <h1 className="media-item">{form_title}</h1>
              </div>
            </div>
            <Switch>
              <Route
                exact
                path="/"
                render={props => (
                  <ViewForm fields={fields} form_help={form_help} {...props} />
                )}
              />
              <Route path="/success" component={ViewSuccess} />
              <Route component={View404} />
            </Switch>
          </div>
          <Footer />
        </div>
      </Router>
    );
  }
}

export default App;
